"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButtonSelect = exports.RadioButtonSelectItem = void 0;
var react_1 = __importDefault(require("react"));
var NoWrapperControl_1 = require("./components/NoWrapperControl");
var NoPanel_1 = require("./components/NoPanel");
var Select_1 = require("./Select");
var NoContentControl_1 = require("./components/NoContentControl");
var RadioButtonSelectItem = function (props) {
    return (react_1.default.createElement("label", { className: "c-label" + (props.isSelected ? " +is-checked" : "") },
        react_1.default.createElement("input", { className: "c-input", type: "radio", checked: props.isSelected, onChange: function (e) { return e.target.checked && props.onSelect(); } }),
        props.option.label));
};
exports.RadioButtonSelectItem = RadioButtonSelectItem;
var RadioButtonSelect = function (props) {
    return (react_1.default.createElement(Select_1.Select, __assign({}, props, { searchable: false, components: {
            Option: exports.RadioButtonSelectItem,
            OptionContainer: NoWrapperControl_1.NoWrapperControl,
            CollapsedControlContainer: NoWrapperControl_1.NoWrapperControl,
            OptionsPanel: NoPanel_1.NoPanel,
            ValueContainer: NoContentControl_1.NoContentControl,
            DropDownContainer: NoWrapperControl_1.NoWrapperControl,
        } })));
};
exports.RadioButtonSelect = RadioButtonSelect;
//# sourceMappingURL=RadioButtonSelect.js.map